import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import icCloseIcon from 'assets/svg/ic_close.svg';
import Button from '@profile/src/Components/Button';

const QRPopup = ({
  isVisible,
  onClose
}) => {
  const userInfo = {
    qr: 'https://yemenbarcodes.com/wp-content/uploads/sites/123/2019/05/qr_code_5cdd30e269752.jpg',
    uuid: '0xedc264...9662900a77'
  };

  const handleCopy = () => {// TODO
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.backdrop, isVisible && styles.show)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    className: styles.close
  }, /*#__PURE__*/React.createElement("img", {
    src: icCloseIcon
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("img", {
    src: userInfo.qr,
    className: styles.qr
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.uuid
  }, userInfo.uuid)), /*#__PURE__*/React.createElement(Button, {
    onClick: handleCopy,
    className: styles.btnCopy,
    title: "Copy code"
  })));
};

export default QRPopup;